import React from "react";
import { Link } from "react-router-dom";
import { Compass, FlaskConical, GraduationCap, Microscope, Stethoscope, Users, ArrowRight } from "lucide-react";

const Eyebrow = ({ children }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className="h-px w-10 bg-medblue" />
    <span className="text-[10px] uppercase tracking-[0.28em] text-medblue">{children}</span>
  </div>
);

const CATEGORIES = [
  { icon: Stethoscope, title: "Medical Careers", desc: "Physician specialties, healthcare professions, and alternative healthcare careers." },
  { icon: Compass, title: "Getting Started", desc: "Finding research opportunities, shadowing physicians, building clinical experience, preparing for college." },
  { icon: FlaskConical, title: "Research", desc: "How to get involved in science and understand medical research." },
  { icon: GraduationCap, title: "Applying", desc: "College and med school application guidance from the people who&rsquo;ve been there." },
  { icon: Microscope, title: "Innovation", desc: "Biomedical engineering, healthcare startups, and the future of medicine." },
  { icon: Users, title: "Mentorship", desc: "Coming soon — direct connections between students and professionals." },
];

export default function Resources() {
  return (
    <div data-testid="resources-page" className="bg-white">
      <section className="border-b border-rule">
        <div className="container-wide py-20 lg:py-24 max-w-5xl">
          <Eyebrow>Student Resource Hub</Eyebrow>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-[68px] leading-[1.03] tracking-tight text-navy">
            Everything you need to explore a life in medicine.
          </h1>
          <p className="mt-8 text-lg text-navy/65 max-w-2xl leading-[1.75]">
            A curated library of guides, articles, and answers — built alongside the interview archive.
          </p>
        </div>
      </section>

      <section className="container-wide py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {CATEGORIES.map((c, i) => (
          <div key={i} className="border border-rule p-8 hover:border-navy transition-colors" data-testid={`resource-${i}`}>
            <c.icon size={26} strokeWidth={1.5} className="text-medblue" />
            <div className="mt-6 font-serif text-2xl text-navy">{c.title}</div>
            <p className="mt-3 text-sm text-navy/65 leading-relaxed">{c.desc}</p>
            <div className="mt-6 text-[10px] uppercase tracking-[0.24em] text-medgreen">Coming soon</div>
          </div>
        ))}
      </section>

      <section className="bg-parchment py-24">
        <div className="container-wide text-center max-w-2xl">
          <h2 className="font-serif text-3xl md:text-4xl text-navy leading-tight tracking-tight">
            The archive comes first. Guides follow.
          </h2>
          <p className="mt-4 text-navy/65 leading-relaxed">
            Meanwhile, dive into the interviews — the real stories that make the guides possible.
          </p>
          <Link to="/interviews" className="btn-primary mt-8 inline-flex">
            Browse Interviews <ArrowRight size={14} className="ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
}
